const ProfessionalDesignations = ({ professionalRegistrations }) => {
  const data = Array.isArray(professionalRegistrations)
    ? professionalRegistrations[0]
    : professionalRegistrations;
  return (
    <div className="review-form">
      <h3>Professional Registrations or Designations</h3>

      <div className="section">
        <div className="row">
          <div className="col-md-8">
            <h4>Registrations</h4>
          </div>
          <div className="col-md-4">
            <h4>
              {data.registrations && data.registrations.length > 0
                ? "Date acquired"
                : "-"}
            </h4>
          </div>
        </div>
        {data.registrations &&
          data.registrations.length > 0 &&
          data.registrations.map((r, idx) => (
            <div className="row" key={idx}>
              <div className="col-md-8" style={{ wordBreak: "break-word" }}>
                {r.state && r.state.trim() !== "" ? r.state : "-"}
              </div>
              <div className="col-md-4">
                {r.date && r.date.trim() !== "" ? r.date : "-"}
              </div>
            </div>
          ))}
      </div>

      <div className="section">
        <div className="row">
          <div className="col-md-8">
            <br />
            <h4>Other Designation(s) held:</h4>
          </div>
          <div className="col-md-4">
            <br />
            <h4>
              {data.designations && data.designations.length > 0
                ? "Date acquired"
                : "-"}
            </h4>
          </div>
        </div>
        {data.designations &&
          data.designations.length > 0 &&
          data.designations.map((d, idx) => (
            <div className="row" key={idx}>
              <div className="col-md-8" style={{ wordBreak: "break-word" }}>
                {d.state && d.state.trim() !== "" ? d.state : "-"}
              </div>
              <div className="col-md-4">
                {d.date && d.date.trim() !== "" ? d.date : "-"}
              </div>
            </div>
          ))}
      </div>
      {data.other_designations && data.other_designations.length > 0 && (
        <div className="section">
          <div className="row">
            <div className="col-md-8">
              <br />
              <h4>Other Designation(s)</h4>
            </div>
            <div className="col-md-4">
              <br />
              <h4>Date acquired</h4>
            </div>
          </div>
          {data.other_designations.map((d, idx) => (
            <div className="row" key={idx}>
              <div className="col-md-8" style={{ wordBreak: "break-word" }}>
                {d.designation && d.designation.trim() !== ""
                  ? d.designation
                  : "-"}
              </div>
              <div className="col-md-4">
                {d.acquiredDate && d.acquiredDate.trim() !== ""
                  ? d.acquiredDate
                  : "-"}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProfessionalDesignations;
